import { gregorianToEthiopic } from "ethiopian-calendar-finova";

export const formatString = (str) => {
  if (typeof str !== 'string') {
    return '';
  }

  return str
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};


export const formatDateTime = (isoString) => {
  if (!isoString) {
    return '';
  }

  const date = new Date(isoString);

  if (isNaN(date.getTime())) {
    return '';
  }

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const year = date.getFullYear();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()];
  const day = padZero(date.getDate());

  let hours = date.getHours();
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12; // Convert to 12-hour format
  hours = hours ? padZero(hours) : '12'; // Convert hour '0' to '12'

  return `${month} ${day}, ${year} `;
};

export function getEthiopicDateTime({
  datetime = new Date(),
  displayHour = false,
  timeFormat = "12h",
}) {
  const dateObj = new Date(datetime);
  const ethiopic = gregorianToEthiopic(dateObj, timeFormat);
  const hourStr =
    displayHour && ethiopic.hour !== undefined
      ? ethiopic.hour.toString().padStart(2, "0")
      : "";
  const minuteStr =
    displayHour && ethiopic.minute !== undefined
      ? ethiopic.minute.toString().padStart(2, "0")
      : "";

  const timeSuffix =
    displayHour && timeFormat === "12h" && ethiopic.ampm
      ? ` ${ethiopic.ampm}`
      : "";

  return (
    <>
      {ethiopic.day}/{ethiopic.month}/{ethiopic.year}
      {displayHour ? ` ${hourStr}:${minuteStr}${timeSuffix}` : ""}
    </>
  );
}
